<div class="container__boletin__section">
  <div class="container__boletin__section__info">
    <h4>Suscríbete a nuestro boletín</h4>
    <p class="mb-0">
      <span class="bold">Recibe ofertas y promociones exclusivas.</span>
      Obtén el acceso directo a los precios más bajos.
    </p>
  </div>
  <div class="container__boletin__section__button">
    <app-button (buttonClick)="openModalBulletin()" [isFullWidth]="true">Suscribirme</app-button>
  </div>
</div>
